import * as React from 'react'
import { Link, Modal } from 'DVWebNodeUI'
import { LocaleSelectionSubMenu } from './LocaleSelector'
import { NavLanguage, NavLink } from 'DVWebNodeUtils';
import { NavParamsProps } from '../index'
import { ProfilesDropdown, ProfilesMenu } from '../../Shared/components/ProfilesMenu';
import { NavProfiles } from '../../Shared/transforms/Profiles';
const indiaModalWeblab = 'DV_PRIMEVIDEO_NAV_LOCALE_RECO_INDIA_221603'
const wwModalWeblab = 'DV_PRIMEVIDEO_NAV_LOCALE_RECO_215720'

interface LinkProps {
  text?: string,
  href?: string,
  rel?: string,
  isHighlighted?: boolean
}

export interface LocaleSelectionSubMenuProps {
  text: string,
  dropdownIndex: number,
  locales: NavLink[],
  languages: NavLanguage[]
}

interface AccountLinksProps {
  links: Array<any>,
  localeSelectionSubMenu: LocaleSelectionSubMenuProps,
  openModal?: Function | null,
  cerberus?: NavProfiles
}

const AccountLinks = ({ links, localeSelectionSubMenu, openModal, cerberus }: AccountLinksProps) => {
  const linkItems = links.slice()
  if (localeSelectionSubMenu) {
    // This is not ideal but we've been hardcoding dropdownIndex since ever .. would be great to get this in WPS at some point
    linkItems.splice(openModal ? (linkItems.length > 2 ? 2 : 0) : localeSelectionSubMenu.dropdownIndex, 0, localeSelectionSubMenu)
  }
  const listItems = linkItems.map(item => {
    if(item.link || item.locales) {
      return (<LocaleSelectionSubMenu locales={item.locales} removeIcon={openModal ? true : false} languages={item.languages} languageToken={item.languageToken} text={item.text || ''} key={item.text} />)
    }
    if(item.isPanel && openModal) {
      return (<li key={item.text} role="menuitem">
      <Link {...item} key={item.text} className="pv-locale-modal" onClick={(e) => {
        e.preventDefault();
        openModal();
      }} />
    </li>)
    }
    return (
      <li key={item.text} role="menuitem">
        <Link {...item} key={item.text} />
      </li>
    )
  })
  if (cerberus) {
    return (
      <ul role="menu">
        <div className="pv-nav-dropl-column nav-profiles-menu">
          {cerberus && <ProfilesMenu {...cerberus} />}
        </div>
        <div className="pv-nav-dropl-column pv-nav-dropl-column-left">
          {listItems}
        </div>
      </ul>
    )
  }
  return (
    <ul role="menu">
      {listItems}
    </ul>
  )
}

const getModalHeader = (links: Array<any>) => {
  const header = links.find((link) => {
    return link.isPanel === true
  })
  return <h2 className="pv-nav-modal-head">{header ? header.text || '' : ''}</h2>
}

type AnnotatedLinkProps = {
  link: LinkProps,
  pre?: string,
  post?: string
} & LinkProps

const AnnotatedLink = (props: AnnotatedLinkProps) => (
  <span>
    {props.pre && <div className="pv-nav-pre-text">{props.pre}</div>}
    <Link {...props} />
    {props.post && <div className="pv-nav-post-text">{props.post}</div>}
  </span>
)

/*
  YourAccountLink should be used only when there is only 1 link.
  We assume when there is only 1 link, that link is an annotated link.
 */

type YourAccountLinkProps = {
  link: AnnotatedLinkProps,
  dropdownExists: boolean
}

const YourAccountLink = ({link, dropdownExists}: YourAccountLinkProps) => {
  if (dropdownExists) {
    return (<span className="pv-nav-link-with-droplist"><AnnotatedLink {...link} /></span>)
  }

  return (<AnnotatedLink {...link} />)
}

/*
  For the dropdown scenerio, we only show the core link
  without pre or post annotations (i.e. non-annotated link).
 */
type YourAccountDropdownProps = {
  links: LinkProps[]
  localeSelectionSubMenu: LocaleSelectionSubMenuProps
  altText?: string
  localeSelectorModal?: JSX.Element | null
  cerberus?: NavProfiles | null
  vtr?: string
  params?: NavParamsProps
}

declare global {
  interface WindowCSM { ue: any; }
}

interface YourAccountDropdownState {
  checked: boolean
  triggered: boolean
}

class YourAccountDropdown extends React.Component<YourAccountDropdownProps, YourAccountDropdownState>{
  constructor(props: YourAccountDropdownProps) {
    super(props)
    this.state = {
      checked: false,
      triggered: false
    }
  }

  modal = React.createRef<Modal>()

  onChange = () => {
    this.setState({ checked: !this.state.checked }, () => {
      if(this.state.checked && !this.state.triggered) {
        const { localeSelectorModal, vtr, params } = this.props
        if (vtr && (window as unknown as WindowCSM).ue && (window as unknown as WindowCSM).ue.trigger) {
          const trigger = (window as unknown as WindowCSM).ue.trigger
          if(params && localeSelectorModal) {
            if(vtr === 'IN') {
              params.isLanguageModalIndia === 'T1' && trigger(indiaModalWeblab, 'T1')
            } else {
              params.isLanguageModal === 'T1' && trigger(wwModalWeblab, 'T1')
            }
          } else if(params) {
            if(vtr === 'IN') {
              params.isLanguageModalIndia === 'C' && trigger(indiaModalWeblab, 'C')
            } else {
              params.isLanguageModal === 'C' && trigger(wwModalWeblab, 'C');
            }
          }
          this.setState({ triggered: true })
        }
      }
    });
  }

  openModal = () => {
    this.modal.current.open()
  }

  render() {
    const { links, localeSelectionSubMenu, altText, localeSelectorModal, cerberus } = this.props
    const accountsContainer = cerberus ?
    <div className='pv-nav-accounts-cerberus nav-profiles pv-nav-dropl' id="pv-nav-accounts-cerberus">
        <ProfilesDropdown {...cerberus} />
        <AccountLinks links={links} openModal={localeSelectorModal ? this.openModal : null} localeSelectionSubMenu={localeSelectionSubMenu} cerberus={cerberus} />
    </div>
    :
    <div className="pv-nav-accounts pv-nav-dropl" id="pv-nav-accounts">
      <input onChange={this.onChange} type="checkbox" autoComplete="off" name="pv-nav-accounts" id="pv-nav-accounts-menu-trigger" className="pv-nav-dropl__input avu-screen-reader-only" />
      <label htmlFor="pv-nav-accounts-menu-trigger" className="pv-nav-dropl__label">
        <span className="pv-nav-account-icon">{altText}</span>
      </label>
      <AccountLinks links={links} openModal={localeSelectorModal ? this.openModal : null} localeSelectionSubMenu={localeSelectionSubMenu} />
    </div>
    
    return (<>
    {accountsContainer}
    {localeSelectorModal && <Modal onClose={() => {
      if(window as unknown as WindowCSM) {
        (window as unknown as WindowCSM).ue.count('DVWebNodeNavLocaleModal', 1);
      }
    }} ref={this.modal} header={getModalHeader(links)}>{localeSelectorModal}</Modal>}
  </>)
  }
}

type YourAccountProps = {
  links: Array<any>,
  localeSelectionSubMenu: LocaleSelectionSubMenuProps,
  altText?: string,
  localeSelectorModal: JSX.Element | null
  vtr?: string
  params: NavParamsProps
  cerberus?: NavProfiles
}

export const YourAccount = ({links, localeSelectionSubMenu, altText, localeSelectorModal, vtr, params, cerberus}: YourAccountProps) => {
  if (links.length === 1) {
    return (
        <span className="pv-nav-accounts-single-link">
        <YourAccountLink link={links[0]} dropdownExists={Boolean(localeSelectionSubMenu)} />
        {localeSelectionSubMenu &&
          <YourAccountDropdown links={Array(links[0])}
            localeSelectionSubMenu={localeSelectionSubMenu} altText={altText} cerberus={cerberus} />}
      </span>      
    )
  }
  return (
    <YourAccountDropdown links={links}
      localeSelectionSubMenu={localeSelectionSubMenu} vtr={vtr} localeSelectorModal={localeSelectorModal} params={params} altText={altText} cerberus={cerberus} />
  )    
}

